<template>
  <div>
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tbody>
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td>
              <input
                type="text"
                class="form-control"
                id="nombreBusqueda"
                name="nombreBusqueda"
                v-model="nombreBusqueda"
                style="width: 500px; text-transform: uppercase"
                required
              />
            </td>
            <td>
              <button
                type="submit"
                class="btn btn-light"
                @click.prevent="getDataPagina(1)"
                title="Buscar registros"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: blue; cursor: pointer"
                  >search</i
                >
                Buscar
              </button>
            </td>
            <td>
              <button
                type="submit"
                class="btn btn-light"
                @click.prevent="getDataPaginaTodos(1)"
                title="Todos los registros"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: blue; cursor: pointer"
                  >auto_awesome_motion</i
                >
              </button>
            </td>
            <td>
              <button
                type="submit"
                class="btn btn-light"
                data-bs-toggle="modal"
                data-bs-target="#ventanaModal"
                @click="abrirModalCrear"
                title="Nuevo registro"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: green; cursor: pointer"
                  >add_box</i
                >
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Número</th>
          <th scope="col">FechaReg</th>
          <th scope="col">Fecha desde</th>
          <th scope="col">Fecha hasta</th>
          <th scope="col">Tipo</th>
          <th scope="col">SuscripcionFechaReg</th>
          <th scope="col">PlanNombre</th>
          <th scope="col">FormaPagoNombre</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="suscripcionaud in datosPaginados"
          :key="suscripcionaud.idSuscripcionAud"
        >
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirModalEditar(suscripcionaud.idSuscripcionAud)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirEditar(suscripcionaud.idSuscripcionAud)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>{{ suscripcionaud.numero }}</td>
          <td>{{ getFormattedDate(suscripcionaud.fechaReg, "DD/MM/YYYY") }}</td>
          <td>
            {{ getFormattedDate(suscripcionaud.fechaDesde, "DD/MM/YYYY") }}
          </td>
          <td>
            {{ getFormattedDate(suscripcionaud.fechaHasta, "DD/MM/YYYY") }}
          </td>
          <td>{{ suscripcionaud.tipo }}</td>
          <td>
            {{
              getFormattedDate(suscripcionaud.suscripcionFechaReg, "DD/MM/YYYY")
            }}
          </td>
          <td>{{ suscripcionaud.planNombre }}</td>
          <td>{{ suscripcionaud.formaPagoNombre }}</td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: red; cursor: pointer"
              @click="deleteSuscripcionAud(suscripcionaud.idSuscripcionAud)"
              title="Borrar"
              >delete</i
            >
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPagina(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idSuscripcionAud" class="form-label"
                      >IdSuscripcionAud</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idSuscripcionAud"
                      name="idSuscripcionAud"
                      v-model="datoSuscripcionAud.idSuscripcionAud"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Suscripcion -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idSuscripcion" class="form-label">
                      Suscripcion</label
                    >
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idSuscripcion"
                      name="idSuscripcion"
                      v-model="datoSuscripcionAud.idSuscripcion"
                    >
                      <option
                        v-for="suscripcion in suscripcions"
                        :value="suscripcion.idSuscripcion"
                        :key="suscripcion.idSuscripcion"
                      >
                        {{ suscripcion.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Suscripcion -->
              <!-- Botón Lista de Valores  Plan -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPlan" class="form-label"> Plan</label>
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idPlan"
                      name="idPlan"
                      v-model="datoSuscripcionAud.idPlan"
                    >
                      <option
                        v-for="plan in plans"
                        :value="plan.idPlan"
                        :key="plan.idPlan"
                      >
                        {{ plan.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Plan -->
              <!-- Botón Lista de Valores  Forma Pago -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idFormaPago" class="form-label">
                      Forma Pago</label
                    >
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idFormaPago"
                      name="idFormaPago"
                      v-model="datoSuscripcionAud.idFormaPago"
                    >
                      <option
                        v-for="formaPago in formaPagos"
                        :value="formaPago.idFormaPago"
                        :key="formaPago.idFormaPago"
                      >
                        {{ formaPago.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Forma Pago -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="numero" class="form-label">Numero</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="numero"
                      name="numero"
                      v-model="datoSuscripcionAud.numero"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaReg" class="form-label"
                      >Fecha de registro</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="fechaReg"
                      name="fechaReg"
                      v-model="datoSuscripcionAud.fechaReg"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaDesde" class="form-label"
                      >FechaDesde</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="date"
                      class="form-control"
                      id="fechaDesde"
                      name="fechaDesde"
                      v-model="datoSuscripcionAud.fechaDesde"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaHasta" class="form-label"
                      >FechaHasta</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="date"
                      class="form-control"
                      id="fechaHasta"
                      name="fechaHasta"
                      v-model="datoSuscripcionAud.fechaHasta"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="tipo" class="form-label">Tipo</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="tipo"
                      name="tipo"
                      v-model="datoSuscripcionAud.tipo"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarSuscripcionAud"
              v-if="btnCrear"
              title="Guardar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >save</i
              >Guardar
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="actualizarSuscripcionAud"
              v-if="btnEditar"
              title="Actualizar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >update</i
              >Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/config';
import api from "@/services/api";    
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";


import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";
export default {
  props: {
    p_idSuscripcion: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      suscripcionauds: [],
      datoSuscripcionAud: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      suscripcions: [],
      plans: [],
      formaPagos: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
    };
  },
  mounted() {
    this.getDataPaginaTodos(this.paginaActual);
    this.fetchSuscripcions();
    this.fetchPlans();
    this.fetchFormaPagos();
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas() {
      return Math.ceil(this.suscripcionauds.length / this.elementosPorPagina);
    },
    getDataPagina(noPagina) {
      if (this.nombreBusqueda != "") {
        api.get("/vwsuscripcionauds/nombre/" +
              this.nombreBusqueda
          )
          .then((response) => {
            this.suscripcionauds = response.data.reverse();
            this.paginaActual = noPagina;
            this.datosPaginados = [];
            let ini =
              noPagina * this.elementosPorPagina - this.elementosPorPagina;
            let fin = noPagina * this.elementosPorPagina;
            this.datosPaginados = this.suscripcionauds.slice(ini, fin);
          });
      }
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwsuscripcionauds")
        .then((response) => {
          this.suscripcionauds = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.suscripcionauds.slice(ini, fin);
        });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarForm() {
      const requiredFields = [
        "idSuscripcion",
        "idPlan",
        "idFormaPago",
        "numero",
        "fechaDesde",
        "fechaHasta",
        "tipo",
      ];
      const requiredFieldsText = [
        "idSuscripcion",
        "idPlan",
        "idFormaPago",
        "numero",
        "fechaDesde",
        "fechaHasta",
        "tipo",
      ];
      return validarForm(
        this.datoSuscripcionAud,
        requiredFields,
        requiredFieldsText
      );
    },
    async guardarSuscripcionAud() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/suscripcionauds",
            this.datoSuscripcionAud
          );
          $("#ventanaModal").modal("hide");
          swal("Correcto!", "SuscripcionAud creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async actualizarSuscripcionAud() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/suscripcionauds",
            this.datoSuscripcionAud
          );
          $("#ventanaModal").modal("hide");
          this.getDataPagina(this.paginaActual);
          swal(
            "Correcto!",
            "SuscripcionAud creado(a) exitosamente!",
            "success"
          );
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors);
          array.forEach((element) => swal(String(element)));
        }
      }
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoSuscripcionAud = {};
      this.titulo = "Crear Suscripción";
      this.btnCrear = true;
      this.btnEditar = false;
    },
    abrirModalEditar(idSuscripcionAud) {
      this.modalWindow = true;
      if (idSuscripcionAud != null) {
        api.get("/vwsuscripcionauds/" + idSuscripcionAud
          )
          .then((resp) => {
            this.datoSuscripcionAud = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Editar Suscripción";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    abrirEditar(idSuscripcionAud) {
      if (idSuscripcionAud != null) {
        this.$router.push("/suscripcionaudmd/" + idSuscripcionAud);
      }
    },
    async deleteSuscripcionAud(idSuscripcionAud) {
      try {
        await api.delete("/suscripcionauds/" + idSuscripcionAud
        );
        this.getDataPagina(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
    fetchSuscripcions() {
      fetch(config.apiBaseUrl + "/suscripcions")
        .then((response) => response.json())
        .then((data) => {
          this.suscripcions = data;
        })
        .catch((error) => {
          console.error("Error fetching suscripcions:", error);
        });
    },
    fetchPlans() {
      fetch(config.apiBaseUrl + "/plans")
        .then((response) => response.json())
        .then((data) => {
          this.plans = data;
        })
        .catch((error) => {
          console.error("Error fetching plans:", error);
        });
    },
    fetchFormaPagos() {
      fetch(config.apiBaseUrl + "/formapagos")
        .then((response) => response.json())
        .then((data) => {
          this.formaPagos = data;
        })
        .catch((error) => {
          console.error("Error fetching formaPagos:", error);
        });
    },
  },
};
</script>
